<template>
  <v-dialog
    v-model="dialog"
  >
    <v-card>
      <v-card-title>
        Primero valida que el proyecto que quieres agregar AÚN NO EXISTA ...
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="items"
          :search="search"
          :loading="isLoading"
        >
          <template v-slot:top>
            <v-text-field
              v-model="search"
              label="Busca aquí el proyecto que deseas agregar"
              outlined
            />
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          @click="close()"
        >
          Cancelar
        </v-btn>
        <v-btn
          text
          color="success"
          @click="onSearchProyectSuccess"
        >
          El nombre no está en esta lista, continuar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import firebase from 'firebase'
  const db = firebase.firestore()

  export default {
    data () {
      return {
        dialog: false,
        isLoading: false,
        items: [],
        headers: [
          { text: 'Proyecto', value: 'nombre' },
        ],
        search: '',
      }
    },
    mounted () {
      this.getProyectos()
    },
    methods: {
      open () {
        this.dialog = true
      },
      close () {
        this.dialog = false
      },
      getProyectos () {
        this.isLoading = true
        var query = db.collection('proyectos')

        query.get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.items.push(doc.data())
          })
          this.isLoading = false
        })
      },
      onSearchProyectSuccess () {
        this.close()
        this.$emit('onSearchProyectSuccess')
      },
    },
  }
</script>
